export const paobcSdk: ISdkResource = {
  type: "built-in",
  goBackHome: () => {
    window.open("https://4gcaz.test-app.link/fan_engagement", "_self");
  },
};
